<template lang="html">
    <div class="toolbar-search">
        <z-select v-model="filter.stock_id" light>
            <option value="" selected>Склад (все)</option>
            <option v-for="stock in stocks" v-bind:value="stock.id" v-bind:key="stock.id">{{ stock.name }}</option>
        </z-select>

        <input
            class="toolbar-search__input" type="text" placeholder="IP или название принтера..."
            v-model="filter.search" v-on:keyup.enter="onFilter" v-on:input="onSearchFilter"
        ></input>

        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-on:click="onReset" v-bind:disabled="!hasFilter"></z-icon-button>
    </div>
</template>
<script>
    import ZSelect     from '@/components/ZSelect.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {ZSelect, ZIconButton},
        data() {
            return {
                filterDefault: {},
                filter: {
                    search: null,
                    stock_id: ''
                }
            }
        },
        created() {
            this.filterDefault = Object.assign({}, this.filter);
            this.resolveQueryFilter();
            this.getStocks();
        },
        computed: {
            /**
             * Список складов в системе, полученный с бэка
             */            
            stocks() {
                return this.$store.state.stock.stocks;
            },            
            /**
             * Флаг, показывающий, есть ли в фильтре хотябы одно значение
             */            
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            }
        },
        watch: {
            'filter.stock_id'(n, o) {
                if (o != n) this.onFilter();
            }
        },        
        methods: {
            /**
             * Преобразует фильтр в URL в объект для работы с фильтрацией
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Получает список грузов с сервера
             */
            getStocks() {
                this.$store.dispatch('stock/getStocks');
            },
            /**
            * Вызывается по событию сброса фильтра
            * сбрасывает фильтр в URL и обновляет таблицу логов
            */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query:  Object.assign({}, query)
                });
                this.$root.$emit('reload-table', 'printers');
            },
            /**
             * Вызывается по событию ввода в поле поиска
             */
            onSearchFilter() {
                if (!this.filter.search || (this.filter.search && this.filter.search.length < 4)) return;
                this.onFilter();
            },
            /**
            * Вызывается по событию фильтрации
            * устанавливает фильтр в URL и обновляет таблицу логов
            */
            onFilter(r) {
                this.$router.push({
                    name:   this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(Object.assign({}, this.filter))
                    }
                });

                this.$nextTick(() => {
                    this.$root.$emit('reload-table', 'printers');
                });
            }
        }
    }
</script>
<style lang="sass"></style>


// WEBPACK FOOTER //
// PrinterToolbar.vue?4123475f